import { render, staticRenderFns } from "./evaluacion-individual-emerito-2026.vue?vue&type=template&id=2bb62d50&scoped=true&"
import script from "./evaluacion-individual-emerito-2026.component.ts?vue&type=script&lang=ts&"
export * from "./evaluacion-individual-emerito-2026.component.ts?vue&type=script&lang=ts&"
import style0 from "./evaluacion-individual-emerito-2026.vue?vue&type=style&index=0&id=2bb62d50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb62d50",
  null
  
)

export default component.exports